import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=37b3fa6a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=37b3fa6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b3fa6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b3fa6a')) {
      api.createRecord('37b3fa6a', component.options)
    } else {
      api.reload('37b3fa6a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=37b3fa6a&scoped=true&", function () {
      api.rerender('37b3fa6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2J9hlIXyWNHpR/JS/comp/GuestBox.vue"
export default component.exports